import { render, staticRenderFns } from "./ExistingCase.vue?vue&type=template&id=12010e56&scoped=true&"
import script from "./ExistingCase.vue?vue&type=script&lang=ts&"
export * from "./ExistingCase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12010e56",
  null
  
)

export default component.exports